import { render } from "./ReferralModal.vue?vue&type=template&id=6490f4f0"
import script from "./ReferralModal.vue?vue&type=script&lang=js"
export * from "./ReferralModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__